import { createContext } from "react";
import type { SeoConfig } from "./types";

export interface SeoManager {
  getConfig: () => SeoConfig | null;
  setConfig: (config: SeoConfig | null) => void;
  reset: () => void;
}

export const createSeoManager = (): SeoManager => {
  let current: SeoConfig | null = null;

  return {
    getConfig: () => current,
    setConfig: (config) => {
      current = config;
    },
    reset: () => {
      current = null;
    },
  };
};

export const SeoContext = createContext<SeoManager | null>(null);
